import axios from 'axios';
import authService from './authService';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL ,
  headers: {
    'Content-Type': 'application/json',
  }
});


apiClient.interceptors.request.use(
  (config) => {
    const method = config.method?.toLowerCase();
    const requiresAuth = ['post', 'put', 'delete', 'patch', 'options'].includes(method);
    
    if (requiresAuth) {
      const token = authService.getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 errors by refreshing token
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 and haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        window.console.log('401 error, refreshing token...');
        
        // Refresh token (calls PHP + Django)
        await authService.refreshToken();
        
        // Retry original request with new token
        const token = authService.getAccessToken();
        originalRequest.headers.Authorization = `Bearer ${token}`;
        
        return apiClient(originalRequest);
      } catch (refreshError) {
        window.console.error('Token refresh failed:', refreshError);
        authService.logout();
        
        // Redirect to login or show error
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;